// Unpublished Work © 2021-2022 Deere & Company

import {SET_EQUIPMENT_DETAILS, SET_EQUIPMENT_DETAILS_TO_DEFAULT, SHOW_EQUIPMENT_ERROR} from '../../action-list';
import {EquipmentDetails} from '../../state/struct/profile/equipment-details';

const setEquipmentDetails = (state, action) =>
    EquipmentDetails.update(state, {
        $merge: {
            ...action.equipmentDetails,
            isEquipmentLoading: false,
            showErrorMessage: false
        }
    });

const showEquipmentError = (state) =>
    EquipmentDetails.update(state, {
        $merge: {
            isEquipmentLoading: false,
            showErrorMessage: true
        }
    });

const setEquipmentsToDefault = () => EquipmentDetails({});

export function equipmentDetails(state = new EquipmentDetails({}), action = {}) {
    const actionHandlers = {
        [SET_EQUIPMENT_DETAILS]: setEquipmentDetails,
        [SHOW_EQUIPMENT_ERROR]: showEquipmentError,
        [SET_EQUIPMENT_DETAILS_TO_DEFAULT]: setEquipmentsToDefault
    };

    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
}
